.title {
  display: flex;
  flex-flow: column nowrap;
  gap: var(--mantine-spacing-xl);
  align-items: center;
}

.title-text {
  position: relative;
  padding: var(--mantine-spacing-sm);
  &::before {
    position: absolute;
    top: 50%;
    left: -50%;
    width: 200%;
    height: 3rem;
    content: '';
    background: radial-gradient(ellipse at center, var(--mantine-color-dark-5) 0%, transparent 70%);
    mix-blend-mode: screen;
    translate: 0 -50%;
  }
}
